import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalComponent } from '../../primeng/modal/modal.component';

@Component({
  selector: 'app-request-access',
  standalone: true,
  imports: [CommonModule, FormsModule, ModalComponent],
  templateUrl: './request-access.component.html',
  styleUrl: './request-access.component.scss',
})
export class RequestAccessComponent implements OnChanges {
  @Input() visible = false;
  @Input() userHasOrganisation = false;
  @Input() organisationName = '';
  /** When false, modal does not close on submit; parent should close on success. */
  @Input() closeOnSubmit = true;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() requestAccessSubmit = new EventEmitter<{
    requestAs: string;
    purposeDescription: string;
    agreeToTerms: boolean;
    organisationName?: string;
  }>();

  requestAs = 'Individual';
  purposeDescription = '';
  agreeToTerms = false;

  get purposeDescriptionLength(): number {
    return this.purposeDescription.length;
  }

  get isFormValid(): boolean {
    if (this.requestAs === 'Organisation' && !this.userHasOrganisation) {
      return false;
    }
    return this.purposeDescription.trim().length > 0 && this.agreeToTerms;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && !this.visible) {
      this.resetForm();
    }
  }

  onClose(): void {
    this.visible = false;
    this.visibleChange.emit(false);
    this.resetForm();
  }

  onSubmit(): void {
    if (!this.isFormValid) return;

    const formData = {
      requestAs: this.requestAs,
      purposeDescription: this.purposeDescription,
      agreeToTerms: this.agreeToTerms,
      ...(this.userHasOrganisation && { organisationName: this.organisationName }),
    };

    this.requestAccessSubmit.emit(formData);
    if (this.closeOnSubmit) {
      this.onClose();
    }
  }

  goToJoinOrganisation(): void {
    this.onClose();
    window.location.href = '/consumer/join-organisation';
  }

  private resetForm(): void {
    this.requestAs = 'Individual';
    this.purposeDescription = '';
    this.agreeToTerms = false;
  }
}
